// @ts-nocheck
import * as React from 'react';
import { Col, Row } from 'reactstrap';
import ProgramCard from '../ProgramCard';
import ProgramGroupWrapper from './ProgramGroup.style';
import type { ProgramGroupProps, ProgramCardListProps } from './ProgramGroup.types';

const ProgramCardList = ({
  programs,
  onSelectProgram,
  onToggleModal,
}: ProgramCardListProps): React.ReactElement<any>[] =>
  programs.map((p) => (
    <Col sm={4} lg={3} key={p.id}>
      <ProgramCard program={p} onSelectProgram={onSelectProgram} onToggleModal={onToggleModal} />
    </Col>
  ));

const ProgramGroup = ({
  programGroup: { name, programs = [] } = {},
  onSelectProgram,
  onToggleModal,
}: ProgramGroupProps): React.ReactElement<any> | null =>
  programs.length > 0 ? (
    <ProgramGroupWrapper>
      <h2 className='program-group__name'>{name}</h2>
      <Row className='program-group__cards-container'>
        <ProgramCardList
          programs={programs}
          onSelectProgram={onSelectProgram}
          onToggleModal={onToggleModal}
        />
      </Row>
    </ProgramGroupWrapper>
  ) : null;

export default ProgramGroup;
